import { useCallback, useEffect, useState } from 'react';

/** A lens of the Plan: loads on mount and when its key changes, and keeps an error to show with Try again. */
export function usePlanView<T>(load: () => Promise<{ success: boolean; data?: T; error?: string }>, key: string) {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    try {
      const r = await load();
      if (!r.success) throw new Error(r.error);
      setData(r.data as T);
      setError(null);
    } catch (e: any) {
      setError(e?.response?.data?.error || e?.message || 'Could not read this view');
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  useEffect(() => {
    setLoading(true);
    void reload();
  }, [reload]);

  return { data, error, loading, reload };
}
